import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: '01',
      name: i18n.t('tipos.fiscalidad_esp.op_sujeta_exenta'),
    },
    {
      id: '02',
      name: i18n.t('tipos.fiscalidad_esp.op_no_sujeta'),
    },
  ]
}

export function TIPOS_FISCALIDAD_ESPECIAL (state) {
  return configHelper.getConfig(state, 'TIPOS_FISCALIDAD_ESPECIAL', GenerateConfig)
}
